import { render, staticRenderFns } from "./ProcessFormCommit.vue?vue&type=template&id=40b46e00&scoped=true&"
import script from "./ProcessFormCommit.vue?vue&type=script&lang=js&"
export * from "./ProcessFormCommit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b46e00",
  null
  
)

export default component.exports